<template>
  <v-container class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card
          style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
        >
          <div v-if="loading" class="px-3 mt-2 py-2">
            <v-progress-linear
              :indeterminate="true"
              color="success"
            ></v-progress-linear>
          </div>

          <v-card-text v-else-if="!logs.length">
            <v-alert
              :value="true"
              outline
              color="success"
              icon="mdi-information"
              class="font-weight-bold"
            >
              No logs found for this ticket.
            </v-alert>
          </v-card-text>

          <v-card-text v-else class="pa-3">
            <v-data-table
              :headers="headers"
              :items="logs"
              :rows-per-page-items="[10, 25, 50, 100, 500, 1000]"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <td class="no-wrap">{{ props.item.time | time }}</td>
                <td>{{ props.item.userName }}</td>
                <td>{{ props.item.operation }}</td>
                <td>
                  <template v-if="props.item.description">
                    <v-btn
                      small
                      flat
                      color="success"
                      @click="expandedId = expandedId === props.item.id ? null : props.item.id"
                    >
                      {{ expandedId === props.item.id ? 'Hide' : 'View' }}
                    </v-btn>
                    <div
                      v-if="expandedId === props.item.id"
                      class="mt-1"
                      v-html="props.item.description"
                    ></div>
                  </template>
                  <span v-else-if="props.item.diffField">
                    <b>{{ props.item.diffField }}: </b>
                    <span v-html="props.item.diffValue"></span>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      logs: [],
      totalCount: 0,
      headers: [
        { text: "Time", value: "time", sortable: false },
        { text: "User", value: "userName", sortable: false },
        { text: "Operation", value: "operation", sortable: false },
        { text: "Details", value: "description", sortable: false },
      ],
      expandedId: null,
      initialLoad: true,
    };
  },
  computed: {
    displayId() {
      return this.initialData && this.initialData.ticket;
    },
  },
  watch: {
    displayId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadLogs();
        }
      },
    },
  },
  methods: {
    async loadLogs() {
      if (!this.displayId) return;
      if (this.initialLoad) {
        this.initialLoad = false;
      }
      this.loading = true;
      try {
        const response = await this.$http.get(
          `/odata/ManageengineLogs?$orderby=Id desc&$count=true&$filter=DisplayId eq '${
            this.displayId
          }'`
        );
        this.logs = response.value;
        this.totalCount = response["@odata.count"];
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.no-wrap {
  white-space: nowrap;
}
</style>
